import React from 'react';

import ROIProvider from 'pages/roiCalculator/submit/context';

const RoiCalculatorPage = React.lazy(() => import('pages/roiCalculator'));
const RoiCalculatorSubmitPage = React.lazy(() => import('pages/roiCalculator/submit'));

const policies = [{ resource: 'trends', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <RoiCalculatorPage />
  },
  {
    path: 'submit',
    policies: policies,
    component: (
      <ROIProvider>
        <RoiCalculatorSubmitPage />
      </ROIProvider>
    )
  },
  {
    path: 'submit/:calcID',
    policies: policies,
    component: (
      <ROIProvider>
        <RoiCalculatorSubmitPage />
      </ROIProvider>
    )
  }
];
